import type { AvailabilityStrategy } from "@loot-os/fulfillment-core/catalog/item";

/**
 * boxed's Retool protocol filter, over the availability strategy the catalog migration mapped it
 * onto (`from-boxed.ts`): a TCG item is sourced as demand arrives, a custom one is on hand.
 */
export const CATALOG_PICKER_TYPES = {
  all: "All types",
  DYNAMIC: "TCG",
  FIXED: "Custom",
} as const satisfies Record<"all" | AvailabilityStrategy, string>;
export type CatalogPickerType = keyof typeof CATALOG_PICKER_TYPES;

/** The tags boxed's Retool offered to filter by, in its order; an item carries them in `tags`. */
export const CATALOG_PICKER_TAGS = [
  "POKEMON",
  "MTG",
  "YUGIOH",
  "ONE_PIECE",
  "LORCANA",
  "RIFTBOUND",
  "DRAGON_BALL",
  "STAR_WARS",
  "DIGIMON",
  "GUNDAM",
] as const;

/** The tag select's items: every tag plus the no-filter entry. */
export const CATALOG_PICKER_TAG_LABELS: Record<string, string> = {
  all: "All tags",
  ...Object.fromEntries(CATALOG_PICKER_TAGS.map((tag) => [tag, tag])),
};

export const CATALOG_PICKER_SORT_LABELS = {
  value_desc: "Highest price",
  value_asc: "Lowest price",
} as const;
export type CatalogPickerSort = keyof typeof CATALOG_PICKER_SORT_LABELS;
